import { INDICES_CHART5_SETTING, INDICES_CHART_OPTION, INDICES_POPUP_OVERLAY } from '@constants/indicesChartBundle';
import type {
  IndicesChartBundlePayload,
  IndicesHtsInterval,
  IndicesPeriod,
} from '@app-types/indices';

export type IndicesChartVariant = 'card' | 'popup';

export interface IndicesChartSource {
  ric: string;
  chartData: string;
  decimalPlaces: number;
}

export const getIndicesChartInterval = (period: IndicesPeriod): IndicesHtsInterval => {
  switch (period) {
    case 'daily':
      return 'd';
    case 'weekly':
      return 'w';
    case 'monthly':
      return 'm';
    default: {
      const exhaustive: never = period;
      return exhaustive;
    }
  }
};

export const buildIndicesChartBundlePayload = (
  source: IndicesChartSource,
  period: IndicesPeriod,
  variant: IndicesChartVariant,
): IndicesChartBundlePayload => {
  const encodedInfoData = encodeURIComponent(JSON.stringify({
    [source.ric]: { timeZone: 'Asia/Tokyo' },
    info: {
      [source.ric]: {
        dp: source.decimalPlaces,
        timeZone: 'Asia/Tokyo',
        timezone: 'Asia/Tokyo',
      },
    },
  }));
  const isPopup = variant === 'popup';
  const overlay = isPopup ? INDICES_POPUP_OVERLAY : {};

  return {
    source: 'labci-chart5',
    theme: 'light',
    ric: source.ric,
    chartData: `\n${source.chartData}`,
    periodType: 'hts',
    chartType: 'candlestick',
    period: '1Y',
    interval: getIndicesChartInterval(period),
    infoData: encodedInfoData,
    overlay: encodeURIComponent(JSON.stringify(overlay)),
    eventData: {},
    chart5Setting: { ...INDICES_CHART5_SETTING },
    chartOption: { ...INDICES_CHART_OPTION },
    showCompare: false,
    showCrosshair: isPopup,
    showMainChart: true,
    showTracker: false,
    showScrollView: isPopup,
    showTA: isPopup,
    showDrawTool: false,
    drag2Slide: isPopup,
    lang: 'ja',
  };
};
